import RedirectionTable from './RedirectionTable';

export default RedirectionTable;
